module.exports = __webpack_public_path__ + "files/00dbe63ad14e680d54a38baed6a8f561.png";